import { render, staticRenderFns } from "./bodyprint-check-view.vue?vue&type=template&id=1a82a876&"
import script from "./bodyprint-check-view.vue?vue&type=script&lang=js&"
export * from "./bodyprint-check-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports